// extracted by mini-css-extract-plugin
export default {"wrapper":"PageTitle_wrapper__V+SZu"};